import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  /** Erklaerung beim Zeigen. Ersetzt keinen sichtbaren Text. */
  title?: string;
}

/**
 * Kurze Zustandsmarke.
 *
 * Der Tonfall faerbt, aber traegt die Aussage nicht: das Wort im Inneren tut
 * es. Ein Badge, das nur durch Rot "fehlgeschlagen" bedeutet, ist fuer
 * Farbenblinde und in Graustufen bedeutungslos.
 */
export function Badge({ tone = 'neutral', children, title }: BadgeProps) {
  return (
    <span className="badge" data-tone={tone} title={title}>
      {children}
    </span>
  );
}
